import { xParetoNormalization } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 */
export function paretoNormalization(data) {
    return {
        data: {
            x: data.x,
            y: xParetoNormalization(data.y),
        },
    };
}
//# sourceMappingURL=paretoNormalization.js.map